<template>
  <div
    v-if="attachmentTypeIdForMacroAudio && sample"
    class="section-editor__container section-macro h-100"
  >
    <description-editor
      ref="macroEditor"
      :description-title="$t('diagnosis.sections.macroscopy')"
      :description-service="sampleMacroService"
      :parent-entity-ids-array="[labId, casId, sample.samId]"
      :laboratory-id="sample.currentLaboratory.labId"
      :case-id="casId"
      :attachment-type-id-for-description-audio="attachmentTypeIdForMacroAudio"
      :attachment-service-for-audio-attachments="sampleAttachmentService"
      :root-filename-for-audio-description="`${sample.samSamplenumber}-MacroAudio-`"
      :disabled="disabled"
      :sample-id="sample.samId"
      :attachment-service="attachmentService"
      modal-confirmation-state-store="diagnoseModalsState"
      modal-confirmation-state-name="diagnoseMacroModalsState"
      modal-confirmation-state-ui-component-code="uicomponent.diagnosis.modalconfig"
      text-template-modal-ui-component-code="uicomponent.diagnosis.templateconfig"
      :hide-attach-operations="!$_canAttachDocumentToSample()"
      :disable-attach-operations="!$_canBeDocumentAttachedToSample(sample)"
      :hide-edit-operations="!$_canEditSample()"
    />
    <div class="d-flex justify-content-end">
      <vt-loading-button
        v-if="$_canEditSample()"
        :disabled="disabled"
        class="btn__outline btn-sm mt-2"
        qa="section-macro-save-button"
        :params="{ promise: save, shortkeys: ['alt', 's'] }"
      >
        <i
          class="fal fa-save mr-2"
          aria-hidden="true"
        />
        {{ $t('global.save') }}
      </vt-loading-button>
    </div>
  </div>
</template>

<script>
import sampleMacroService from '@/api/resources/description/SampleMacroService'
import DescriptionEditor from '@/components/description/DescriptionEditor'
import attachmentTypeService, { ATTACHMENT_TYPES } from '@/api/resources/attachment/attachmentTypeService'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import sampleAttachmentService from '@/api/resources/attachment/sampleAttachmentService'
import sampleMacroAttachmentService from '@/api/resources/description/attachment/sampleMacroAttachmentService'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'

export default {
    name: 'SectionMacro',
    components: {
        DescriptionEditor
    },
    mixins: [
        SampleOperationGuardMixin
    ],
    props: {
        labId: { type: Number, required: true },
        casId: { type: Number, required: true },
        sample: { type: Object, required: true },
        disabled: { type: Boolean, required: true }
    },
    data() {
        return {
            attachmentTypeIdForMacroAudio: null
        }
    },
    computed: {
        sampleMacroService() {
            return sampleMacroService
        },
        sampleAttachmentService() {
            return sampleAttachmentService
        },
        attachmentService() {
            return sampleMacroAttachmentService
        }
    },
    async created() {
        await this._loadAttachmentTypeIdForMacroAudio()
    },
    methods: {
        async reloadTab() {
            await this._loadAttachmentTypeIdForMacroAudio()
            await this.$refs.macroEditor.loadData()
        },
        hasBeenChanged() {
            return this.$refs.macroEditor.hasBeenChanged()
        },
        async save() {
            const saveCallback = await this.$refs.macroEditor.save()
            if (saveCallback) {
                this.$emit('reloadSummary')
                return saveCallback
            }
        },
        async _loadAttachmentTypeIdForMacroAudio() {
            const response =
                await this.$_toCallUnique(
                    attachmentTypeService.getAttachmentType(
                        ATTACHMENT_ENTITY_TYPE.SAMPLE,
                        ATTACHMENT_TYPES.MACRO_EXAMNATION_AUDIO))
            if (response) {
                this.attachmentTypeIdForMacroAudio = response.atyId
            }
        }
    }
}
</script>

<style lang="scss">
.section-macro .ql-toolbar.ql-snow {
  padding: 2px;
}

.section-macro .ql-editor {
  transition: 0.35s;
  overflow-y: auto;
}

/*--Styles for large screen--*/
@media (max-width: 1300px) {
  .section-macro .static-audio-col .ar-icon {
    width: 25px;
    height: 25px;
  }

  .section-macro .audio-box .btn {
    font-size: font-size(normal);
  }
}

/*--Sizes for laptop screen--*/
@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .section-macro .ql-editor {
    transition: 0.35s;
    overflow-y: auto;
  }
}
</style>

<style lang="scss" scoped>

.static-audio-col {
  flex: 0 0 350px !important;
}

.audio-scroll {
  min-height: calc(100vh - 930px);
  max-height: calc(100vh - 460px);
  overflow-y: auto;
  transition: 0.35s;
}

@media (max-width: 1370px) {
  .audio-scroll {
    min-height: calc(100vh - 915px);
    max-height: calc(100vh - 450px);
    overflow-y: auto;
    transition: 0.35s;
  }

  .static-audio-col {
    flex: 0 0 250px !important;
  }

  .audio-click span {
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: font-size(small);
  }
}

/*--Sizes for laptop screen--*/
@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .audio-scroll {
    min-height: calc(100vh - 620px);
    max-height: calc(100vh - 470px);
    overflow-y: auto;
    transition: 0.35s;
  }

  .static-audio-col {
    flex: 0 0 250px !important;
  }
}
</style>
